import { Company } from '@models/company/company';
import { Field } from '@models/company/field';
import { Facet } from '@models/search/facet';
import { Page } from '@models/search/page';
import { City, GeoPoint } from '@wizbii/models';

export class Filter {
  static readonly type = '[SearchCompanies] Filter';

  constructor(public keywords: any, public city: City, public fieldFacets: Facet<Field>[], public page: number) {}
}

export class FilterSuccess {
  static readonly type = '[SearchCompanies] Filter Success';

  constructor(public result: Page<Company>) {}
}

export class FilterFailed {
  static readonly type = '[SearchCompanies] Filter Failed';

  constructor(public error: any) {}
}

export class LoadMore {
  static readonly type = '[SearchCompanies] Load More';

  constructor(
    public keywords: any,
    public geoPoint: GeoPoint,
    public fieldFacets: Facet<Field>[],
    public page: number
  ) {}
}

export class LoadMoreSuccess {
  static readonly type = '[SearchCompanies] Load More Success';

  constructor(public result: Page<Company>) {}
}

export class LoadMoreFailed {
  static readonly type = '[SearchCompanies] Load More Failed';

  constructor(public error: any) {}
}

export class InitFields {
  static readonly type = '[SearchCompanies] Init Fields';
}
